import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Form, Button, Row, Col } from "react-bootstrap";
import Message from "../../components/Message";
import Loader from "../../components/Loader";
import FormContainer from "../../components/FormContainer";
import { toast } from "react-toastify";
import {
  useGetProductDetailsQuery,
  useUpdateProductMutation,
  useUploadProductImageMutation,
} from "../../slices/productsApiSlice";import { useGetCategoriesQuery } from '../../slices/categoriesApiSlice';
const ProductEditScreen = () => {
  const { id: productId } = useParams();

  const [name, setName] = useState("");
  const [price, setPrice] = useState(0);
  const [image, setImage] = useState("");
  const [countInStock, setCountInStock] = useState(0);
  const [description, setDescription] = useState("");
  const [forAge, setForAge] = useState("");
  const [sortOrder, setSortOrder] = useState(0);
  const [category, setCategory] = useState('');
  const [enableCustomComment, setEnableCustomComment] = useState(false);

  const { data: categories } = useGetCategoriesQuery();

  const {
    data: product,
    isLoading,
    refetch,
    error,
  } = useGetProductDetailsQuery(productId);

  const [updateProduct, { isLoading: loadingUpdate }] =
    useUpdateProductMutation();

  const [uploadProductImage, { isLoading: loadingUpload }] =
    useUploadProductImageMutation();

  const navigate = useNavigate();

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await updateProduct({
        productId,
        name,
        price,
        image,
        description,
        forAge,
        countInStock,
        sortOrder,
        category: category || null,
        enableCustomComment,
      });
      toast.success("המוצר עודכן בהצלחה");
      refetch();
      navigate("/admin/productlist");
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  useEffect(() => {
    if (product) {
      setName(product.name);
      setPrice(product.price);
      setImage(product.image);
      setCountInStock(product.countInStock);
      setDescription(product.description);
      setForAge(product.forAge);
      setSortOrder(product.sortOrder || 0);
      setCategory(product.category?._id || product.category || '');
      setEnableCustomComment(product.enableCustomComment || false);
    }
  }, [product]);

  const uploadFileHandler = async (e) => {
    const formData = new FormData();
    formData.append("image", e.target.files[0]);
    try {
      const res = await uploadProductImage(formData).unwrap();
      toast.success(res.message);
      setImage(res.image);
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <>
      <div className="text-end">
        <Link to="/admin/productlist" className="btn btn-light my-3">
          חזור
        </Link>
      </div>
      <FormContainer>
        <h1 className="text-end">ערוך מוצר</h1>
        {loadingUpdate && <Loader />}
        {isLoading ? (
          <Loader />
        ) : error ? (
          <Message variant="danger">{error.data.message}</Message>
        ) : (
          <Form onSubmit={submitHandler}>
            <Form.Group controlId="name">
              <Col xs={12} className="text-end">
                <Form.Label>שם</Form.Label>
              </Col>
              <Form.Control
                type="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                dir="rtl"
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId="price">
              <Col xs={12} className="text-end">
                <Form.Label>מחיר</Form.Label>
              </Col>
              <Form.Control
                type="number"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                dir="rtl"
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId="image">
              <Col xs={12} className="text-end">
                <Form.Label>תמונה</Form.Label>
              </Col>
              <Form.Control
                type="text"
                placeholder="Enter image url"
                value={image}
                onChange={(e) => setImage(e.target.value)}
              ></Form.Control>
              <Form.Control
                label="Choose File"
                onChange={uploadFileHandler}
                type="file"
              ></Form.Control>
              {loadingUpload && <Loader />}
            </Form.Group>
            <Form.Group controlId="forAge">
              <Col xs={12} className="text-end">
                <Form.Label>לגיל</Form.Label>
              </Col>
              <Form.Control
                type="text"
                value={forAge}
                onChange={(e) => setForAge(e.target.value)}
                dir="rtl"
              ></Form.Control>
            </Form.Group>
            <Form.Group controlId="countInStock">
              <Col xs={12} className="text-end">
                <Form.Label>כמות במלאי</Form.Label>
              </Col>
              <Form.Control
                type="number"
                value={countInStock}
                onChange={(e) => setCountInStock(e.target.value)}
                dir="rtl"
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId="sortOrder">
              <Col xs={12} className="text-end">
                <Form.Label>סדר תצוגה</Form.Label>
              </Col>
              <Form.Control
                type="number"
                value={sortOrder}
                onChange={(e) => setSortOrder(Number(e.target.value))}
                dir="rtl"
              ></Form.Control>
            </Form.Group>
            <Form.Group controlId='category'>
              <Col xs={12} className='text-end'>
                <Form.Label>קטגוריה</Form.Label>
              </Col>
              <Form.Select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                dir='rtl'
                className='text-end'
              >
                <option value=''>ללא קטגוריה</option>
                {categories &&
                  categories.map((cat) => (
                    <option key={cat._id} value={cat._id}>
                      {cat.name}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>
            <Form.Group controlId="enableCustomComment">
              <Col xs={12} className="text-end">
                <Form.Label>הערת לקוח על המוצר</Form.Label>
              </Col>
              <div className="d-flex justify-content-end align-items-center gap-2 mb-2">
                <Form.Label className="mb-0">אפשר הערת לקוח</Form.Label>
                <Form.Check
                  type="switch"
                  id="enableCustomComment"
                  checked={enableCustomComment}
                  onChange={(e) => setEnableCustomComment(e.target.checked)}
                />
              </div>
            </Form.Group>

            <Form.Group controlId="description">
              <Col xs={12} className="text-end">
                <Form.Label>תיאור</Form.Label>
              </Col>
              <Form.Control
                as="textarea"
                rows={10}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                dir="rtl"
              ></Form.Control>
            </Form.Group>

            <Row className="my-2">
              <Col className="d-flex justify-content-end">
                <Button
                  type="submit"
                  variant="primary"
                  style={{ marginTop: "1rem" }}
                >
                  עדכן
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </FormContainer>
    </>
  );
};

export default ProductEditScreen;
